module.exports = __webpack_public_path__ + "img/cloth_g1_shirt_12.0b471795.svg";